export default __webpack_public_path__ + "20d8eb478d56679d8890b59f017c7a98.png";